(function ($) {
	"use strict";

	/*** Slick ***/
	$(".slick").slick();

	$(window).on("orientationchange",function(){
	    $('[data-slick]').slick('resize');
	});

	/*** Sticky Header ***/
	$(window).scroll(function(){
	    if ($(window).scrollTop() >= 125) {
	        $('#header').addClass('header--sticky');
	        $('.header--topbar').hide();
	    }
	    else {
	        $('#header').removeClass('header--sticky');
	        $('.header--topbar').show();
	    }
	});

	/*** Tooltips ***/
	$('[data-toggle="tooltip"]').tooltip();

	/*** Hide Top Bar ***/
	checkIconClicked();

  function checkIconClicked() {
    const dataMsg = localStorage.getItem('message-close');
    if (!dataMsg) {
      $(".header--topbar").removeAttr("hidden");
    }
  }

  $(".header--topbar .icon-close").on("click", function() {
		localStorage.setItem('message-close', 'true');
		$(".header--topbar").hide();
	});


	/*** Hover Header ***/ 
	if ($(window).width() > 992){
		if (!$('#header').hasClass('header--hovered')) {
			$(".header--megamenu--item").mouseover(function() {
				$("#header").addClass("header--hovered");
			}).mouseout(function() {
				$("#header").removeClass("header--hovered");
			});
		}
	
		$('#header .dropdown').on('show.bs.dropdown', function(){
			$("#header").addClass("header--hovered");
		});

		$('#header .dropdown').on('hide.bs.dropdown', function(){
			$("#header").removeClass("header--hovered");
		});  
	}

	$('#header-search').on('show.bs.collapse', function(){
		$("#header").addClass("header--hovered");
	});

	$('#header-search').on('hide.bs.collapse', function(){
		$("#header").removeClass("header--hovered");
	});

	/*** Mobile Menu ***/
	var menu = new MmenuLight(
		document.querySelector( '#header-mobile' ),
		"(max-width: 992.98px)"
	);

	var navigator = menu.navigation({
		theme: 'light',
		title: 'Menu'
	});
/*
	document.addEventListener(
		"DOMContentLoaded", () => {
			const drawer = menu.offcanvas();

			document.querySelector( ".header--burger" )
			.addEventListener( 'click', ( evnt ) => {
				evnt.preventDefault();
				drawer.open();
			});

			document.querySelector( ".header--close" )
			.addEventListener( 'click', ( evnt ) => {
				evnt.preventDefault();
				drawer.close();
			});
		}
	);
*/
	/*** Marquee ***/
	$('.marquee').marquee({
		duration: 10000,
		gap: 0,
		delayBeforeStart: 0,
		direction: 'left',
		duplicated: true
	});

	/*** Breadcrumb ***/
	if ($("body").hasClass("template-product")) {
		$(".subheader").addClass("breadproduit");
	}

	/*** Mini Cart ***/
	$(".minicart--close, .minicart-bottom-close, body").on("click", function() {
		$("#minicart").removeClass("active");
	});

	/*** Product Variants ***/
	var radios = $('.ficheproduit--diamondchoice input[type="radio"]');

	radios.on("click", function() {
	    radios.each(function() {
	    	$(this).parent().toggleClass("current", this.checked);
	    });

	    $("#ficheproduit-no-variant-error").hide();
	});

	/*** Filters Shadow ***/
	$(document).click(function(){
		$("#filters .dropdown-menu.show").closest("filter--toggle").click();
	});

	if ($(window).width() > 991.98) {
		$("body").on('DOMSubtreeModified', '#AjaxinateContainer', function(){
	    	$(document).click(function(){
				$("#filters .dropdown.show, #filters .dropdown-menu.show").removeClass("show");
			});
		});
	}
	
	$(document).on('click', '#filters .dropdown-menu', function (e) {
      e.stopPropagation();
    });
	if ($(window).width() < 992) {
		$(".filters--togglemobile").on("click", function() {
			$('<div class="filters--open"></div>').appendTo(document.body);
			$("html").addClass("noscroll");
		});

		$(document).on("click", ".filters--close", ".filter--apply", function() {
			$(".filters--open").remove();
			$("html").removeClass("noscroll");
		});

		$(document).on('click', '.filters--open', function() {
		    $(".filters--close").click();

		    if (!$("#filters").hasClass("show")) {
		    	$(".filters--open").remove();
		    	$("html").removeClass("noscroll");
		    }
		});

		$(document).on('click', '.filter--apply', function() {
		    $(".filters--close").click();

		    if (!$("#filters").hasClass("show")) {
		    	$(".filters--open").remove();
		    	$("html").removeClass("noscroll");
		    }
		});
	}

	var CmsHeader = $('.cmspage--header');	

	// For Mobile
	if (window.matchMedia("(max-width: 767px)").matches) {
		HeaderCmsSwitcher('image-mobile', 'video-mobile');
	} else {
		HeaderCmsSwitcher('image', 'video');
	}

	function HeaderCmsSwitcher(imageData, videoData) {
		var imageUrlHeaderCms = CmsHeader.data(imageData);
		var videoUrlHeaderCms = CmsHeader.find('iframe').data(videoData);

		if ( videoUrlHeaderCms != undefined && videoUrlHeaderCms != "" ){
			CmsHeader.addClass('videoheader')
			CmsHeader.find('iframe').attr('src', videoUrlHeaderCms);
		} else {
			if ( imageUrlHeaderCms != "" )
				CmsHeader.css('background-image', 'url('+ imageUrlHeaderCms +')');
		}
	}

})(jQuery);